import { analyticsApiUrl } from '../config'
import { getJWT } from './auth'

type UnauthorizedError = {
  status: 401
  title: 'Not Authenticated'
  detail: 'Authentication credentials were not provided.'
  code: 'not_authenticated'
}

type ServiceUnavailableError = {
  status: 503
  title: 'Service Unavailable'
  detail: 'External service responded unexpectedly'
  code: 'invalid_service_response'
}

type ValidationError = {
  status: 400
  errors: CreateInvoiceError[]
  title: 'Validation Error'
  code: 'invalid'
}

type PermissionDenied = {
  status: 403
  title: 'Permission Denied'
  detail: 'You do not have permission to perform this action.'
  code: 'permission_denied'
}

export type CommonErrors =
  | UnauthorizedError
  | ServiceUnavailableError
  | ValidationError
  | PermissionDenied

type CreateInvoiceError = {
  jobId: string
  stafferId: string
  error: string
}

export type SendJobEmailsSuccess = {
  status: 200
  title: string,
}

export type SendJobEmailsRequest = {
  jobId: string,
  confirm: boolean,
}

export type SendJobEmailsResponse = SendJobEmailsSuccess | CommonErrors


export const sendJobEmails = async (request: SendJobEmailsRequest): Promise<SendJobEmailsResponse> => {
  const token = await getJWT()
  const response = await fetch(`${analyticsApiUrl}/api/v1/send-job-notifications`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(request),
  })

  return (await response.json()) as SendJobEmailsResponse
}
